import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-situacao-filter-dropdown',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule
  ],
  templateUrl: './situacao-filter-dropdown.component.html',
  styleUrls: ['./situacao-filter-dropdown.component.scss']
})
export class SituacaoFilterDropdownComponent {
  @Input() opcoes: { valor: string; label: string }[] = [];
  @Input() valorSelecionado: string | null = null;
  @Input() placeholder = 'Situação';
  @Input() maxVisivel: number | null = null;
  @Output() valorChange = new EventEmitter<string | null>();

  isOpen = false;

  constructor(private elementRef: ElementRef) {}

  get dropdownMaxHeight(): string | null {
    if (this.maxVisivel === null) return null;
    // cada opção tem ~40px (py-2.5 = 20px top+bottom + linha ~20px)
    return `${this.maxVisivel * 40}px`;
  }

  get labelSelecionada(): string {
    if (!this.valorSelecionado) return this.placeholder;
    return this.opcoes.find(o => o.valor === this.valorSelecionado)?.label || this.placeholder;
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  selecionar(valor: string): void {
    const novoValor = valor === this.valorSelecionado ? null : valor;
    this.valorChange.emit(novoValor);
    this.isOpen = false;
  }

  limpar(event: Event): void {
    event.stopPropagation();
    this.valorChange.emit(null);
    this.isOpen = false;
  }

  trackByOpcao(_index: number, opcao: { valor: string; label: string }): string {
    return opcao.valor;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.isOpen = false;
  }
}
